<template>
  <nav class="text-sm" aria-label="Breadcrumb">
    <ol class="flex flex-wrap items-center gap-x-2">
      <li class="flex items-center gap-x-2">
        <router-link
          :to="homeRoute"
          class="text-wusa-navy-400 hover:underline"
          aria-label="Home"
        >
          <i class="fas fa-home"></i>
        </router-link>
        <span v-if="items.length" class="text-gray-400" aria-hidden="true">/</span>
      </li>
      <li
        v-for="(item, index) in items"
        :key="index"
        class="flex items-center gap-x-2"
      >
        <router-link
          v-if="item.to && index < items.length - 1"
          :to="item.to"
          class="text-wusa-navy-400 hover:underline"
        >
          {{ item.label }}
        </router-link>
        <span
          v-else
          class="text-gray-600"
          :aria-current="index === items.length - 1 ? 'page' : undefined"
        >
          {{ item.label }}
        </span>
        <span v-if="index < items.length - 1" class="text-gray-400" aria-hidden="true">/</span>
      </li>
    </ol>
  </nav>
</template>

<script setup>
defineProps({
  items: { type: Array, required: true },
  homeRoute: { type: Object, required: true },
});
</script>
